import React from 'react'
import TextField from '@material-ui/core/TextField'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import { EditorConvertToHTML } from '../myeditor'
import LiveHelpTwoToneIcon from '@material-ui/icons/LiveHelpTwoTone'
import ArrowDropDownCircle from "@material-ui/icons/ArrowDropDownCircle"
import TitleEditor from './TitleEditor'

export default function({
    handleFormChange, 
    setActiveSection, 
    setUploadOpen,
    sopState,
    setSopState,
    attachments,
    children, 
}){

    const { records, text } = { ... attachments?.attachments?.doc } 
    let masterDoc = sopState["masterDoc"]?sopState["masterDoc"]:"";
    let typeOfDoc = sopState["typeOfDoc"]?sopState["typeOfDoc"]:"";
    let documentKey = sopState["documentKey"]?sopState["documentKey"]:"";
    let name = sopState["name"]?sopState["name"]:"";
    let title=masterDoc+"-"+typeOfDoc+"-"+documentKey+" "+name;
    return (
        <div>
            <h2>Support Document</h2>
            <form noValidate autoComplete="off">
            <div>
                    <TitleEditor  id="titleEditor"
                     handleFormChange={handleFormChange}
                     setActiveSection={setActiveSection}
                     setUploadOpen={setUploadOpen}
                     sopState={sopState}
                     setSopState={setSopState}
                    />
                </div>
                <div>
                    <TextField id="title" label="Title" value={title} 
                    onChange={(e) => handleFormChange(e)} 
                    style={{width:'80%', marginBottom:20}}
                    />
                </div>
                
                <div style={{ width:'90%', paddingLeft:'10%', paddingBottom:30 }}>
                    <ExpansionPanel>
                        <ExpansionPanelSummary
                            expandIcon={<ArrowDropDownCircle />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <LiveHelpTwoToneIcon style={{ color: typeof text !== 'undefined' ? 'green' : 'gray', }}
                                onClick={ () => {
                                    setActiveSection("text")
                                    setUploadOpen(true)
                                }}
                            />
                            <h3>Document text</h3>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails style={{ marginLeft:'5%', marginRight:'5%', minHeight:350, overflow:'hidden'  }}>
                            <EditorConvertToHTML 
                                html={sopState?.text} 
                                update={ (val) => {
                                    setSopState({...sopState, text: val})
                                }}
                            />
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </div>

                <div style={{ width:'90%', paddingLeft:'10%', paddingBottom:30 }}>
                    <ExpansionPanel> 
                        <ExpansionPanelSummary
                            expandIcon={<ArrowDropDownCircle />}
                            aria-controls="panel1a-content-records"
                            id="panel1a-header-records"
                        >
                            <LiveHelpTwoToneIcon style={{ color: typeof records !== 'undefined' ? 'green' : 'gray', }}
                                onClick={ () => {
                                    setActiveSection("records")
                                    setUploadOpen(true)
                                }}
                            />
                            <h3>Records</h3>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails style={{ marginLeft:'5%', marginRight:'5%', minHeight:350, overflow:'hidden'  }}>
                            <EditorConvertToHTML 
                                html={sopState?.records} 
                                update={ (val) => {
                                    setSopState({...sopState, records: val})
                                }}
                            />
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </div>
                {children}
            </form>
        </div>
    )
}